import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmailVerification from './pages/EmailVerification';
import ResendVerification from './pages/ResendVerification';
import SubscriptionComplete from './pages/SubscriptionComplete';
import PricingPlans from './pages/PricingPlans';
import PaymentDetails from './pages/PaymentDetails';
import OnboardingOrganization from './pages/OnboardingOrganization';
import OnboardingPersonal from './pages/OnboardingPersonal';
import OnboardingPreferences from './pages/OnboardingPreferences';
import Dashboard from './pages/Dashboard';
import Appointments from './pages/Appointments';
import Referrals from './pages/Referrals';
import Messages from './pages/Messages';
import ClientPortal from './pages/ClientPortal';
import PortalPaymentSuccess from './pages/PortalPaymentSuccess';
import TeamInviteAccept from './pages/TeamInviteAccept';
import MyPatients from './pages/MyPatients';
import AddPatient from './pages/AddPatient';
import PatientForm from './pages/PatientForm';
import PatientDetail from './pages/PatientDetail';
import IntakeForm from './pages/IntakeForm';
import IntakeForms from './pages/IntakeForms';
import Analysis from './pages/Analysis';
import Billing from './pages/Billing';
import ClinicalHub from './pages/ClinicalHub';
import Tasks from './pages/Tasks';
import ProgressNotes from './pages/ProgressNotes';
import Settings from './pages/Settings';
import FormBuilderPage from './pages/FormBuilderPage';
import PrivateRoute from './components/PrivateRoute';
import { useReportNotifications } from './hooks/useReportNotifications';
import './App.css';

function App() {
  // Initialize WebSocket notifications for real-time PDF/report updates
  useReportNotifications();

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route path="/resend-verification" element={<ResendVerification />} />
        <Route path="/subscription-complete" element={<SubscriptionComplete />} />
        <Route path="/complete-subscription" element={<SubscriptionComplete />} />
        <Route path="/portal/payment-success" element={<PortalPaymentSuccess />} />
        <Route path="/portal/:token" element={<ClientPortal />} />
        <Route path="/team-invite/:token" element={<TeamInviteAccept />} />

        {/* Protected Routes - Payment and Onboarding */}
        <Route element={<PrivateRoute />}>
          <Route path="/pricing-plans" element={<PricingPlans />} />
          <Route path="/payment-details" element={<PaymentDetails />} />
          <Route path="/onboarding/organization" element={<OnboardingOrganization />} />
          <Route path="/onboarding/personal" element={<OnboardingPersonal />} />
          <Route path="/onboarding/preferences" element={<OnboardingPreferences />} />

          {/* Dashboard and App Routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/referrals" element={<Referrals />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/patients" element={<MyPatients />} />
          <Route path="/add-patient" element={<AddPatient />} />
          <Route path="/patient/new" element={<PatientForm />} />
          <Route path="/patient/edit/:id" element={<PatientForm />} />
          <Route path="/patient/:id" element={<PatientDetail />} />
          <Route path="/intake-forms" element={<IntakeForms />} />
          <Route path="/intake-form/view/:id" element={<IntakeForm />} />
          <Route path="/intake-form/edit/:id" element={<IntakeForm />} />
          <Route path="/intake-form/:patientId" element={<IntakeForm />} />
          <Route path="/intake-form" element={<IntakeForm />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/clinical-ops" element={<ClinicalHub />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/progress-notes" element={<ProgressNotes />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/form-builder" element={<FormBuilderPage />} />
        </Route>

        {/* Default Redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      {/* Toast Container for Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: 99999 }}
      />
    </Router>
  );
}

export default App;